import { RAIL_BY_STATUS } from "@components/AsEmployeeCheckpointInspectionCard/asEmployeeCheckpointInspectionCardRails";
import { normalizeCardStatus } from "@components/AsEmployeeCheckpointInspectionCard/asEmployeeCheckpointInspectionCardConstants";

export {
  CARD_TYPES,
  STATUS_BY_TYPE,
  CHIP_VARIANTS,
  RAIL_BY_STATUS,
  RAIL_COLOR_BY_TONE,
} from "@components/AsEmployeeCheckpointInspectionCard/asEmployeeCheckpointInspectionCardConstants";

/**
 * Coach v2 status-rail tones per Figma (45508:16656).
 * Inspection failed rail varies by checkpoint type — unlike the employee card.
 */
export const COACH_RAIL_BY_STATUS = {
  ...RAIL_BY_STATUS,
  "Inspection failed": "red",
  "Not Applicable": "blue",
};

const INSPECTION_ONLY_TYPES = new Set(["Video + Inspection", "Article + Inspection"]);

/**
 * Resolve coach v2 rail tone from Type × Status (Figma AsCoachCheckpointInspectionCard).
 * The status is normalised first (ER-11601) so the legacy vocabulary from
 * `buildChecklistInspectionLevels` and the new enum (`inspection_failed`,
 * `not_applicable`, …) resolve to the same tone.
 */
export function coachRailTone(status, type) {
  const normalizedStatus = normalizeCardStatus(status) || String(status || "").trim();
  const normalizedType = (type || "").trim();

  if (normalizedStatus === "inspection_failed") {
    if (normalizedType === "Inspector-only") return "grey";
    if (INSPECTION_ONLY_TYPES.has(normalizedType)) return "orange";
    return "red";
  }

  return COACH_RAIL_BY_STATUS[normalizedStatus] || "grey";
}
